<div class="mct-grid ecom-item-grid mct-gap-27">
  <div>
    <label>{{ 'ecommerce.item.name' | translate | ucfirst }}</label>
    <input class="form-control" name="title" [(ngModel)]="eCommerceItem.Title" required />
  </div>
  <div>
    <div>&nbsp;</div>
    <p-checkbox [(ngModel)]="eCommerceItem.Inactive" binary="true" inputId="itemInactive" name="inactive"> </p-checkbox>
    <label for="itemInactive">
      {{ 'ecommerce.item.item-is-inactive' | translate | ucfirst }}
    </label>
  </div>
  <div>
    <label>{{ 'ecommerce.item.type' | translate | ucfirst }}</label>
    <p-select
      appendTo="body"
      name="itemNum"
      [(ngModel)]="eCommerceItem.ItemTypeId"
      [placeholder]="'common.select-dashes' | translate | ucfirst"
      [style]="{ width: '100%' }"
      [options]="ecommerceTypes"
      showClear
      required
    ></p-select>
  </div>
  <div style="margin-bottom: -20px">
    <label>{{ (enableMemberPrice ? 'ecommerce.item.non-member-price' : 'ecommerce.item.price') | translate | ucfirst }}</label>
    <div class="p-inputgroup">
      <span class="atlas-input-addon">$</span>
      <input type="currency" class="form-control" name="price" [(ngModel)]="eCommerceItem.Price" required />
    </div>
    <p-checkbox [(ngModel)]="enableMemberPrice" (onChange)="setMemberPrice()" binary="true" class="mt-5" inputId="enableMemberPrice">
    </p-checkbox>
    <label for="enableMemberPrice">
      {{ 'ecommerce.item.member-pricing' | translate | ucfirst }}
    </label>
  </div>
  <div>
    <label>{{ 'ecommerce.item.revenue-item' | translate | ucfirst }}</label>
    <p-select
      appendTo="body"
      name="itemNum"
      [(ngModel)]="eCommerceItem.ItemNum"
      [placeholder]="'common.select-dashes' | translate | ucfirst"
      [style]="{ width: '100%' }"
      [options]="revenueItems"
      showClear
      required
      appendTo="body"
    ></p-select>
  </div>
  <div [hidden]="!enableMemberPrice">
    <label>{{ 'ecommerce.item.member-price' | translate | ucfirst }}</label>
    <div class="p-inputgroup">
      <span class="atlas-input-addon">$</span>
      <input
        type="currency"
        class="form-control"
        name="memberPrice"
        [(ngModel)]="eCommerceItem.MemberPrice"
        [required]="enableMemberPrice"
      />
    </div>
  </div>
  <div [hidden]="enableMemberPrice">&nbsp;</div>
  <label>
    <label>{{ 'ecommerce.item.item-categories' | translate | ucfirst }}</label>
    <div class="atlas-autocomplete">
    <p-autocomplete
      [suggestions]="filteredCategories"
      [(ngModel)]="selectedCategories"
      [inputStyle]="{ width: '100%' }"
      (completeMethod)="filterCategories($event)"
      [dataKey]="'EcomCategoryId'"
      optionLabel="EcomCategory1"
      [multiple]="true"
      [forceSelection]="true"
      (onSelect)="catagorySelected()"
      (onUnselect)="catagorySelected()"
      appendTo="body"
      name="categories"
    >
    </p-autocomplete>
    </div>
  </label>
  <div class="mct-col-1-span-2-gt-sm">
    <label>{{ 'ecommerce.item.description' | translate | ucfirst }}</label>
    <wl-wysiwyg-editor name="description" [showHtmlTemplates]="false" [disableImageSelector]="true" [(ngModel)]="eCommerceItem.Descr">
    </wl-wysiwyg-editor>
  </div>
</div>
